export const FcuIDs = {
    0x81: 1, // FCU1 ID
    0x82: 2, // FCU2 ID
    0x83: 3, // FCU3 ID
    0x84: 4, // FCU4 ID
    0x85: 5, // FCU5 ID
    0x86: 6, // FCU6 ID
    0x87: 7, // FCU7 ID
    0x88: 8, // FCU8 ID
};
